module.exports = __webpack_public_path__ + "static/media/obligation-pastor2.bd1d9c38.jpg";